<template>
    <a :href="`${getPlSlug(car)}`" :class="['pls-card', 'card d-flex', 'flex-column', 'text-decoration-none', 'w-100', 'mt-2', 'h-100']">
      <div class="card-img-top aspect-ratio-4-3 crc-img-container cover br-tl-4 br-tr-4 position-relative">
        <img :src="car.image" alt="car.model" class="image-fluid" />
        <div class="pls-fuel-icon-wrapper">
            <simple-svg
                :src="iconContent"
                fill-class-name="fuel-icons"
                width="20"
                height="20"
            />
        </div>
      </div>
      <div class="px-3 px-md-4 px-lg-4 py-3 card-body d-flex flex-column">
        <h3 class="pls-car-title mb-1">{{ car.brand }} {{ car.model }}</h3>
        <p class="mt-1 mb-3 pls-car-version card-text flex-grow-1 crc-gray-text text-truncate" v-html="car.version"></p>
        <div class="flex-wrap mt-0 card-usps d-flex">
          <span class="me-2 px-1 py-1 pls-card-usp">{{ car.transmission }}</span>
          <span class="me-2 px-1 py-1 pls-card-usp">{{ car.fuel }}</span>
        </div>
        <div class="mt-4 pls-card-price-container d-flex justify-content-between align-items-center">
          <div class="pls-price-label">
            <span class="mb-1 crc-gray-text fw-normal">Prijs vanaf:</span>
          </div>
          <div class="pls-car-price">
            <span class="pls-car-action-price">€{{ getFormattedPrice() }},-</span>
          </div>
        </div>
        <div class="pls-divider"></div>
        <div class="flex-wrap mt-1 pls-card-dealer-info d-flex flex-column text-wrap">
          <span class="pls-card-dealer-info-text">
            Prijs vanaf: €{{ getFormattedPrice() }} o.b.v {{ car.price_from.duration.label }} -
            {{ car.price_from.km }} km/jaar
          </span>
        </div>
        <div class="pls-card-action-btn-wrapper">
          <a :href="`${getPlSlug(car)}`">{{ ctaText }}</a>
        </div>
      </div>
    </a>
</template>

<script>
import { mapStores } from 'pinia'
import { useCarStore } from "@/stores/car";
import { inject } from 'vue'


export default {
  components: {
  },
  setup() {
    const plsContext = inject('plsContext')
    return { plsContext }
  },
  data() {
    return {
      carPrice: 0,
      brand: '',
      translateDict: {
        "Benzine":"benzine",
        "Diesel":"diesel",
        "Hybride":"hybride",
        "Elektrisch":"elektrisch",
        "ECO-G (LPG)":"eco_g",
        "L": 'lpg_g3'
      },
    }
  },
  props: {
    car: {
      type: Object,
      required: true
    },
    ctaText: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapStores(useCarStore),
    fuelIconType() {
      return this.translateDict[this.car.fuel] || '';
    },
    iconContent() {
      const vueUrl = this.plsContext?.vueUrl || '';
      const icons = {
        benzine: vueUrl + 'img/benzine.svg',
        diesel: vueUrl + 'img/diesel.svg',
        elektrisch: vueUrl + 'img/elektrisch.svg',
        hybride: vueUrl + 'img/hybride.svg',
        eco_g: vueUrl + 'img/lpg.svg',
        lpg_g3: vueUrl + 'img/lpg.svg',
      };

      return icons[this.translateDict[this.car.fuel]] || '';
    }
,
  },
  methods: {
    domain() {
      return window.location.host;
    },
    getFormattedPrice() {
      const price = this.carStore.extractPrice(this.car);
      return this.formatNumber(price);
    },

    formatNumber(number) {
      return Number(number).toLocaleString('nl-NL').replace(/,/g, '.');
    },
    getslug(car) {
      return window.getslug(car);
    },


    slugify(str) {
      return String(str)
          .normalize('NFKD') // split accented characters into their base characters and diacritical marks
          .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
          .trim() // trim leading or trailing whitespace
          .toLowerCase() // convert to lowercase
          .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
          .replace(/\s+/g, '-') // replace spaces with hyphens
          .replace(/-+/g, '-'); // remove consecutive hyphens
    },
    getPlSlug(car) {
      const host = window.location.origin;
      let brand = car.brand.replace(/[\W_]+/g, "-")

      // model/version/fuel/transmission must stay unslugified: ComposeCar.vue
      // in private-lease-frontend uses the model path segment as-is in its
      // API call, and matches version/fuel/transmission against the raw API
      // values with only whitespace->hyphen + lowercase. Slugifying here
      // (stripping punctuation, e.g. "ECO-G (LPG)") makes both fail.
      return  host + '/' +
          this.slugify(brand ) +'/private-lease/model/' +
          encodeURIComponent(car.model) + '?version=' +
          encodeURIComponent(car.version) + '&fuel-type=' +
          encodeURIComponent(car.fuel) + '&transmission=' +
          encodeURIComponent(car.transmission) + '&carReference=' + car.id;


    },
  },
  mounted() {

  }
};
</script>
